import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TransporterLayout from "../../components/TransporterLayout/TransporterLayout";
import { fetchMyTrips } from "../../lib/directus";
import styles from "./TransporterTrips.module.css";

function mapTrip(load) {
  const batch  = load.order?.batch || {};
  const myBid  = (load.bids || []).find(b => b.status === 'Won') || (load.bids || [])[0];
  const STATUS_LABEL = {
    transport_sourced: 'Transport sourced',
    pending_dispatch:  'Pending dispatch',
    pickup_completed:  'Pickup completed',
    in_transit:        'In transit',
    delivered:         'Delivered',
  };
  const status = STATUS_LABEL[load.order?.fulfillment_status] || 'In transit';

  return {
    id:       load.id,
    loadRecordId: load.id,
    orderId:  load.order?.id || null,
    loadId:   load.load_id ? `#${load.load_id}` : `#${String(load.id || '').slice(0, 8).toUpperCase()}`,
    pickup:   load.pickup_location || '-',
    delivery: load.delivery_location || '-',
    cargo:    batch.commodity
                ? `${batch.commodity}${batch.grade ? ` (${batch.grade})` : ''}`
                : '-',
    quantity: batch.quantity ? `${batch.quantity} MT` : '-',
    driver:   load.assigned_driver?.name || '-',
    date:     load.date_updated
                ? new Date(load.date_updated).toLocaleDateString('en-ZA', {
                    day: 'numeric', month: 'short', year: 'numeric',
                  })
                : '-',
    earned:   myBid?.bid_amount ? `R${parseFloat(myBid.bid_amount).toLocaleString()}` : '-',
    status,
    distance:      '-',
    estimatedTime: '-',
  };
}

const TABS = ["All", "Transport sourced", "Pending dispatch", "Pickup completed", "In transit", "Delivered"];

export default function TransporterTrips() {
  const navigate   = useNavigate();
  const [trips, setTrips]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [activeTab, setActiveTab] = useState("All");

  useEffect(() => {
    fetchMyTrips()
      .then(data => setTrips(data.map(mapTrip)))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const filtered = activeTab === "All" ? trips : trips.filter(t => t.status === activeTab);

  return (
    <TransporterLayout>
      <div className={styles.page}>
        <h1 className={styles.pageTitle}>Trips</h1>

        {/* Tabs */}
        <div className={styles.tabsRow}>
          {TABS.map((tab) => (
            <button
              key={tab}
              className={`${styles.tab} ${activeTab === tab ? styles.tabActive : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {loading && <p style={{ color: 'var(--secondary-text)', padding: '2rem 0', fontSize: 14 }}>Loading...</p>}

        {!loading && filtered.length === 0 && (
          <p style={{ color: 'var(--secondary-text)', padding: '2rem 0', fontSize: 14 }}>No trips found.</p>
        )}

        {!loading && filtered.length > 0 && (
          <div className={styles.cardsGrid}>
            {filtered.map((trip) => (
              <div
                key={trip.id}
                className={styles.tripCard}
                onClick={() => navigate(`/trips/${trip.id}`, { state: { trip } })}
              >
                <div className={styles.cardHeader}>
                  <div className={styles.cardTop}>
                    <span className={styles.loadIdText}>{trip.loadId}</span>
                    <span className={trip.status === "Delivered" ? styles.badgeDelivered : styles.badgeInTransit}>
                      {trip.status}
                    </span>
                  </div>
                </div>
                <div className={styles.cardBody}>
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Route</span>
                    <span className={styles.infoValue}>{trip.pickup} → {trip.delivery}</span>
                  </div>
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Cargo</span>
                    <span className={styles.infoValue}>{trip.cargo}</span>
                  </div>
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Driver</span>
                    <span className={styles.infoValue}>{trip.driver}</span>
                  </div>
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Date</span>
                    <span className={styles.infoValue}>{trip.date}</span>
                  </div>
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Earned</span>
                    <span className={styles.oliveValue}>{trip.earned}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </TransporterLayout>
  );
}
